var HlxMenuItem_1;
import { __decorate } from "tslib";
import { customElement, property, state } from 'lit/decorators.js';
import { localized } from '@lit/localize';
import HelixElement from '../../shared/types/helix-element.js';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { menuItemStyles } from './menu.styles.js';
import { nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { consume } from '@lit/context';
import { dividersContext, menuSizeContext } from './menu-context.js';
import '../icon/icon.js';
import { literal, html } from 'lit/static-html.js';
import { ifDefined } from 'lit-html/directives/if-defined.js';
let HlxMenuItem = HlxMenuItem_1 = class HlxMenuItem extends HelixElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.variant = 'default';
        this.target = '_self';
        this.role = 'none';
    }
    render() {
        const hasNextSiblingItem = this.nextSibling instanceof HlxMenuItem_1;
        const isLink = !!this.href;
        const tag = isLink ? literal `a` : literal `button`;
        return html `
            <${tag}
                class=${classMap({
            'hlx-menu-item': true,
            'hlx-menu-item-medium': this.size === 'medium',
            'hlx-menu-item-small': this.size === 'small',
            'hlx-menu-item-divider': this.dividers && hasNextSiblingItem,
            'hlx-menu-item-delete': this.variant === 'delete',
        })}
                role="menuitem"
                ?disabled=${this.disabled}
                @keydown=${this.handleKeyDown}
                aria-selected=${ifDefined(this.selected)}
                aria-disabled=${this.disabled}
                href=${ifDefined(isLink && !this.disabled ? this.href : undefined)}
                target=${ifDefined(isLink ? this.target : undefined)}
                download=${ifDefined(isLink ? this.download : undefined)}
                @click=${this.emitHlxClick}>
                <slot></slot>
                ${this.renderSelectedIcon()}
            </${tag}>
        `;
    }
    renderSelectedIcon() {
        if (this.selected === undefined) {
            // not selectable
            return nothing;
        }
        const isSelected = this.selected === 'true';
        return html `
            <div class="hlx-menu-item-selected-icon-container">
                ${isSelected ?
            html `
                        <hlx-icon name="check" decorative size="16"></hlx-icon>
                    `
            : nothing}
            </div>
        `;
    }
    emitHlxClick() {
        this.emit('hlx-click', undefined, { bubbles: true });
    }
    handleKeyDown(event) {
        let direction;
        switch (event.code) {
            case 'ArrowRight':
            case 'ArrowDown':
                direction = 'next';
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                direction = 'prev';
                break;
        }
        if (direction) {
            event.preventDefault();
            this.emit('hlx-menu-item-focus', { direction }, { bubbles: true });
        }
    }
};
HlxMenuItem.shadowRootOptions = { ...HelixElement.shadowRootOptions, delegatesFocus: true };
HlxMenuItem.styles = [componentStyles, menuItemStyles];
__decorate([
    property({ type: Boolean, reflect: true })
], HlxMenuItem.prototype, "disabled", void 0);
__decorate([
    property({ type: String })
], HlxMenuItem.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], HlxMenuItem.prototype, "selected", void 0);
__decorate([
    property({ type: String })
], HlxMenuItem.prototype, "href", void 0);
__decorate([
    property({ type: String })
], HlxMenuItem.prototype, "target", void 0);
__decorate([
    property({ type: String })
], HlxMenuItem.prototype, "download", void 0);
__decorate([
    property({ reflect: true })
], HlxMenuItem.prototype, "role", void 0);
__decorate([
    state(),
    consume({ context: dividersContext, subscribe: true })
], HlxMenuItem.prototype, "dividers", void 0);
__decorate([
    state(),
    consume({ context: menuSizeContext, subscribe: true })
], HlxMenuItem.prototype, "size", void 0);
HlxMenuItem = HlxMenuItem_1 = __decorate([
    customElement('hlx-menu-item'),
    localized()
], HlxMenuItem);
export { HlxMenuItem };
//# sourceMappingURL=menu-item.js.map